import { vendorAddressFormSchema } from './create-form.js';
import { createVendorAddressInputSchema } from './create-input.js';
export function toCreateVendorAddressInput(values, vendorName) {
    const parsed = vendorAddressFormSchema.parse(values);
    return createVendorAddressInputSchema.parse({
        name: vendorName,
        addressName: parsed.addressName,
        typeId: Number(parsed.typeId),
        address: parsed.address,
        city: parsed.city ?? null,
        stateId: parsed.stateId ?? null,
        countryId: parsed.countryId ?? null,
        zip: parsed.zip ?? null,
        ...(parsed.defaultFlag === true ? { defaultFlag: true } : {}),
    });
}
//# sourceMappingURL=create-mapper.js.map